
/* injects from baggage-loader */

'use strict';

import AccountAddNewBankAccountController from './account.add-new-bank-account.controller';
import AccountAddNewBankAccountTemplate from './account.add-new-bank-account.html';

export default class AccountAddNewBankAccountComponent {
		constructor() {
				this.templateUrl = AccountAddNewBankAccountTemplate;
				this.controller = AccountAddNewBankAccountController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/add-new-bank-account/account.add-new-bank-account.component.js